import axiosInstance from "@/axiosInstance";

const state = () => ({
    users: [],
    roles: [],
    settingLoaded: false,
});

const mutations = {
  SET_USERS(state, users) {
      state.users = users;
  },
  SET_ROLES(state, roles) {
    state.roles = roles;
},
  SET_SETTING_LOADED(state, loaded) {
      state.usersLoaded = loaded;
  },
  CLEAR_SETTING_DATA(state) {
      state.users = [];
      state.roles = [];
      state.usersLoaded = false;
  },
};

const actions = {
  async fetchSettingsData({ state, commit }) {
    if (state.settingLoaded) return;
    try {
      const [userRes, roleRes] = await Promise.all([
        axiosInstance.get("users/"),
        axiosInstance.get("roles/"),
      ]);
      commit("SET_USERS", userRes.data);
      commit("SET_ROLES", roleRes.data);
      commit("SET_SETTING_LOADED", true);
    } catch (error) {
      console.error("Failed to fetch user data:", error);
    }
  },
  // async fetchPositionInfo(_, slug) {
  //     try {
  //         const response = await axiosInstance.get(`onboard/positions/${slug}/`);
  //         return response.data;
  //     } catch (error) {
  //         console.error("Failed to fetch position by slug:", error);
  //         throw error;
  //     }
  // }
};

const getters = {
  getUsers: (state) => state.users,
  getRoles: (state) => state.roles,
  isSettingLoaded: (state) => state.settingLoaded,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};